import { ProviderCategoryModel } from './provider-category.model';

export class PropertyProviderCategoryModel
{
    public id: string; 
    public provider_category_id: string;
    public provider_category: ProviderCategoryModel;
    public variance_threshold: number = 0.25;
    public minimum_variance: number = 50;
    public final_bill_adjustment: number;
    public minimum_vacant_amount: number = 50;
    public floorplan_variance_threshold: number = 1;
    public floorplan_minimum_variance: number = 100;
    public service_fee_enabled: boolean = false;

    // used to determine audit meta fileds
    public client_prebill_floorplan_variances:boolean= false;
    public client_prebill_month_over_month_variances:boolean= false;

}